<template lang="pug">
  .jumpseller-oauth-callback
    .jumpseller-oauth-callback-background
      b-container(fluid="lg")
        b-row.h-100(align-h="center" align-v="center")
          b-col(sm="8" md="6" xl="4")
            b-card.jumpseller-oauth-callback-card
              b-row(align-h="center")
                b-col(cols="auto")
                  img.jumpseller-oauth-callback-logo(src="../assets/logos/original.png")
              .jumpseller-oauth-callback-body.text-center
                template(v-if="status === 'success'")
                  b-icon.jumpseller-oauth-callback-icon-success(icon="check-circle-fill" variant="success" font-scale="3")
                  h4 Integración Jumpseller instalada correctamente
                  p La tienda quedó conectada con 12 Horas Envíos.
                template(v-else-if="status === 'not_linked'")
                  b-icon(icon="info-circle-fill" variant="primary" font-scale="3")
                  h4 Falta vincular tu cuenta de 12 Horas Envíos
                  p Para terminar la instalación, inicia sesión en 12 Horas Envíos, ve a Integraciones y presiona "Conectar con Jumpseller".
                template(v-else-if="status === 'denied'")
                  b-icon(icon="x-circle-fill" variant="warning" font-scale="3")
                  h4 Autorización cancelada
                  p No se otorgaron permisos en Jumpseller. Puedes intentarlo nuevamente desde Integraciones.
                template(v-else)
                  b-icon.jumpseller-oauth-callback-icon-error(icon="x-circle-fill" variant="danger" font-scale="3")
                  h4 No se pudo completar la integración con Jumpseller
                  p Inténtalo nuevamente o escríbenos a contacto@12horasenvios.com.
                b-button(
                  variant="primary"
                  :to="{ name: 'IntegrationView' }"
                ) Volver a integraciones
</template>

<script>
export default {
  computed: {
    status() {
      return this.$route.query.status
    }
  }
}
</script>

<style lang="scss" scoped>
.jumpseller-oauth-callback {
  height: 100%;
  background: var(--secondary);

  &-background {
    height: 100vh;
    padding-top: 30px;
  }

  &-card {
    border: 0;
    box-shadow: 0 3px 6px #00000029;
  }

  &-logo {
    height: 60px;
    margin-top: 22px;
  }

  &-body {
    padding: 30px 10px 20px;
  }
}
</style>
